<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>科研项目绩效点</v-toolbar-title>
      <span class="subheading ml-2">|</span>
      <v-btn color="primary" class="ml-3" @click.native.stop="onNewItem">新建</v-btn>
      <v-dialog v-model="dialog" max-width="700px">
        <v-card>
          <v-form v-model="dialogValid" ref="form" lazy-validation>
            <v-card-title>
              <span class="subheading">{{formTitle}}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs6>
                    <v-select
                      label="项目版本名称"
                      item-text="name"
                      item-value="dbid"
                      autocomplete
                      clearable
                      required
                      :rules="rules.versionId"
                      :loading="versionLoading"
                      :items="versionItems"
                      :search-input.sync="versionSearch"
                      v-model="editedItem.versionId"
                      v-on:keyup.enter="onVersionSearch"
                      :append-icon-cb="onVersionSearch"
                      hint="输入关键词检索"
                      persistent-hint
                    />
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      label="项目级别名称"
                      item-text="name"
                      item-value="dbid"
                      autocomplete
                      clearable
                      required
                      :rules="rules.LevelId"
                      :loading="levelLoading"
                      :items="levelItems"
                      :search-input.sync="levelSearch"
                      v-model="editedItem.levelId"
                      v-on:keyup.enter="onLevelSearch"
                      :append-icon-cb="onLevelSearch"
                      hint="输入关键词检索"
                      persistent-hint
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      label="项目类型"
                      item-text="name"
                      item-value="dbid"
                      autocomplete
                      clearable
                      required
                      :rules="rules.typeId"
                      :loading="typeLoading"
                      :items="typeItems"
                      :search-input.sync="typeSearch"
                      v-model="editedItem.typeId"
                      v-on:keyup.enter="onTypeSearch"
                      :append-icon-cb="onTypeSearch"
                      multiple
                      max-height="400"
                      hint="选择类型"
                      persistent-hint
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field label="项目经费下限（单位：元）" :rules="rules.fundDown" v-model="editedItem.fundDown"/>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field label="项目经费上限（单位：元）" :rules="rules.fundUpper" v-model="editedItem.fundUpper"/>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field label="基准经费绩点（单位：元）" required :rules="rules.benchMark" v-model="editedItem.benchMark"/>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      label="项目性质"
                      item-text="name"
                      item-value="dbid"
                      :rules="rules.required"
                      :items="[{dbid:'sk',name:'社科项目'},{dbid:'zk',name:'自科项目'}]"
                      v-model="editedItem.projProperty"
                      max-height="400"
                      hint="选择项目性质"
                      persistent-hint
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn color="blue darken-1" flat @click.native="clear">取消</v-btn>
              <v-btn color="primary"
                     :disabled="!dialogValid"
                     @click.native="save">保存
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-spacer/>
      <v-spacer/>
      <v-text-field
        append-icon="search"
        label="按名称检索…"
        v-model="search"
      />
    </v-toolbar>
    <v-divider/>
    <v-data-table
      :headers="headers"
      :search="search"
      :loading="loading"
      :total-items="total"
      :pagination.sync="pagination"
      item-key="dbid"
      :items="items"
      no-data-text="没有数据。"
      no-results-text="没有符合条件的记录。"
    >
      <template slot="items" slot-scope="props">
        <td>
          {{ props.index + 1}}
        </td>
        <td>{{ props.item.version.name }}</td>
        <td>{{ props.item.number}}</td>
        <td>{{ props.item.level.name}}</td>
        <td>{{ formatTypes(props.item.types) }}</td>
        <td>{{ props.item.fundDown }}</td>
        <td>{{ props.item.fundUpper }}</td>
        <td>{{ props.item.benchMark }}</td>
        <td>{{stateMap[props.item.flag]}}</td>
        <td>{{propertyMap[props.item.projProperty]}}</td>
        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn icon class="mx-0"
                   slot="activator" @click="onEditItem(props.item)">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <span>编辑</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0"
                   slot="activator" @click="onConfirmDeleteItem(props.item)">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
            <span>删除</span>
          </v-tooltip>
        </td>
      </template>
      <!--<template slot="pageText" slot-scope="props">-->
      <!--显示第 {{props.pageStart}} - {{props.pageStop}} 条记录，共 {{props.itemsLength}} 条记录。-->
      <!--</template>-->
    </v-data-table>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title>
          <span>确定要删除该条目吗？</span>
        </v-card-title>
        <v-card-text class="headline">
          {{deleteText}}
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click.stop="dialogDelete=false">取消</v-btn>
          <v-btn color="primary" flat @click.stop="onDeleteItem">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
  export default {
    data() {
      return {
        // 期刊表格
        headers: [
          {text: '#', align: 'left', sortable: false, value: 'dbid', width: "2rem"},
          {text: '版本名称', align: 'left', sortable: true, value: 'version'},
          {text: '版本号', align: 'left', sortable: true, value: 'number'},
          {text: '项目级别', align: 'left', sortable: true, value: 'level'},
          {text: '项目类型', align: 'left', sortable: true, value: 'types'},
          {text: '项目经费下限（元）', align: 'left', sortable: false, value: 'fundDown'},
          {text: '项目经费上线（元）', align: 'left', sortable: false, value: 'fundUpper'},
          {text: '基准经费（元）', align: 'left', sortable: false, value: 'benchMark'},
          {text: '有效标识', align: 'left', sortable: false, value: 'flag'},
          {text: '项目性质', align: 'left', sortable: false, value: 'projProperty'},
          {text: '操作', align: 'center', sortable: false, value: 'dbid'}
        ],
        stateMap: {
          yes: "有效",
          no: "无效"
        },
        propertyMap: {
          zk: "自科项目",
          sk: "社科项目"
        },
        loading: false,
        total: 0,
        pagination: {},
        items: [],

        //版本号
        versionLoading: false,
        versionItems: [],
        versionSearch: "",

        //类型名称
        levelLoading: false,
        levelItems: [],
        levelSearch: "",

        typeLoading: false,
        typeItems: [],
        typeSearch: "",

        // 检索框
        search: '',
        searchKey: 'name',



        // 编辑对话框
        dialog: false,
        dialogValid: true,
        editedIndex: -1,
        editedItem: {
          "versionId":"",
          "version": "",
          "number": "",
          "levelId":"",
          "level":"",
          "typeId":"",
          "types":"",
          "fundDown":"",
          "fundUpper":"",
          "benchMark":"",
          "flag": "",
          "projProperty":""
        },
        defaultItem: {
          "versionId":"",
          "version": "",
          "number": "",
          "levelId":"",
          "level":"",
          "typeId":"",
          "types":"",
          "fundDown":"",
          "fundUpper":"",
          "benchMark":"",
          "flag": "",
          "projProperty":""
        },
        rules: {
          versionId: [
            v => !!v || '必填项。'
          ],
          levelId: [
            v => !!v || '必填项。'
          ],
          benchMark:[
            v => (v && /^[0-9]*$/g.test(v)) || '请输入数字。'
          ]
         /* fundDown:[
            v => (v && /^[0-9]*$/g.test(v)) || '请输入数字。'
          ],
          fundUpper:[
            v => (v && /^[0-9]*$/g.test(v)) || '请输入数字。'
          ]*/
        },

        // 删除对话框
        dialogDelete: false,
        deleteLoading: false,
        deleteIndex: -1,
        deleteDbid: '',
        deleteText: ''
      }
    },
    created() {
      // 组件创建完后获取数据，
      // 此时 data 已经被 observed 了
    },
    watch: {
      // 如果路由有变化，会再次执行该方法
      '$route': 'get',
      pagination: {
        handler: 'get',
        deep: true
      }
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? '新建' : '编辑'
      }
    },
    methods: {
      formatTypes(types) {
        if (types)
          return types.map(
            a => a.name
          ).join(', ');
      },
      paginationParams(p) {
        let params = {};
        if (p.sortBy) {
          params.sort = p.sortBy + (p.descending ? '.desc' : '.asc')
        }
        if (p.page) {
          params.page = p.page - 1
        }
        if (p.rowsPerPage) {
          params.limit = p.rowsPerPage
        }
        return params;
      },
      searchParams(k, v) {
        v = v.trim();
        let params = {};
        if (k && v.length > 0) {
          params[k] = v;
        }
        return params;
      },
      //检索版本
      onVersionSearch() {
        let params = {};
        if (this.versionSearch) {
          const val = this.versionSearch.trim();
          if (val.length > 0) {
            params["name"] = val;
          }
        }
        const vm = this;
        vm.versionLoading = true;
        this.axios.get('/api/perf/Version', {params: params}).then(
          rsp => {
            vm.versionLoading = false;
            vm.versionItems = rsp.data.items;
          })
      },
      //检索级别
      onLevelSearch() {
        let params = {};
        if (this.levelSearch) {
          const val = this.levelSearch.trim();
          if (val.length > 0) {
            params["name"] = val;
          }
        }
        const vm = this;
        vm.levelLoading = true;
        this.axios.get('/api/perf/projectLevel', {params: params}).then(
          rsp => {
            vm.levelLoading = false;
            vm.levelItems = rsp.data.items;
          })
      },
      // 项目类别
      onTypeSearch() {
        const param = window.xutil.param("name", this.typeSearch);
        const vm = this;
      // var versionId = vm.editedItem.versionId;
     //   if (versionId.length > 0) {
      //      param["versionId"] = versionId;
      //   }
        param ["limit"] = 1000;
        vm.typeLoading = true;
        this.axios.get('/api/proj/project-type', {params: param})
          .then(
            rsp => {
              vm.typeLoading = false;
              vm.typeItems = rsp.data.items
            })
      },

      // diff(trg,src){
      //   Object.keys(trg).map()
      // },
      save() {
        window.console.debug("SAVE");
        // todo, only submit modified fields
        if (this.$refs.form.validate()) {
          if (this.editedIndex < 0) {
            this.post(this.editedItem)
          } else {
            this.put(this.items[this.editedIndex].dbid, this.editedItem)
          }
        }
      },
      clear() {
        this.dialog = false;
        this.$refs.form.reset()
      },
      post(data) {
        const vm = this;
        this.axios.post('/api/perf/projectLevelScore', data).then((rsp) => {
          vm.items.unshift(rsp.data);
          vm.total = vm.total + 1;
          vm.dialog = false;
        })
      },
      put(dbid, data) {
        const vm = this;
        this.axios.put('/api/perf/projectLevelScore/' + dbid, data).then((rsp) => {
          vm.items[vm.editedIndex] = rsp.data;
          vm.dialog = false;
        })
      },
      get() {
        window.console.debug("GET");
        const vm = this;
        vm.loading = true;
        const params = Object.assign(
          this.paginationParams(vm.pagination), this.searchParams(vm.searchKey, vm.search)
        );
        this.axios.get('/api/perf/projectLevelScore', {
          params: params
        }).then((rsp) => {
          vm.loading = false;
          vm.items = rsp.data.items.map(
            v => {
              return v;
            });
          vm.total = rsp.data.total;
        })
      },
      onNewItem() {
        this.editedIndex = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
        //this.defaultItem = {};
        this.$refs.form.reset();
        this.dialog = true
      },
      onEditItem(item) {
        this.$refs.form.reset();
        this.editedIndex = this.items.indexOf(item);
        this.editedDbid = item.dbid;
        this.dialog = true;
        const vm = this;
        this.axios.get('/api/perf/projectLevelScore/' + this.editedDbid)
          .then(rsp => {
            const it = rsp.data;
            // 填充编辑对话框
            vm.editedItem = it;
            // 填充编辑对话框
            vm.versionItems = it.version ? [it.version] : [];
            vm.levelItems = it.level ? [it.level] : [];
            vm.types = it.types ? [it.types] : [];
            vm.typeItems = it.types;
            //vm.typeId = it.types.map(t => t.dbid);
         //   vm.typeItems = item.typeItems;
            this.dialog = true
            // 保存默认数据
            vm.defaultItem = window.xutil.clone(this.editedItem);
          });
      },
      onConfirmDeleteItem(item) {
        this.deleteText = item.name;
        this.deleteDbid = item.dbid;
        this.deleteIndex = this.items.indexOf(item);
        this.dialogDelete = true;
      },
      onDeleteItem() {
        const vm = this;
        vm.deleteLoading = true;
        this.axios.delete('/api/perf/projectLevelScore/' + vm.deleteDbid).then(() => {
          this.items.splice(vm.deleteIndex, 1);
          this.total = this.total - 1;
          this.deleteIndex = -1;
          this.dialogDelete = false;
        })
      }
    }
  }
</script>
<style scoped>
  div.toolbar__content div.input-group {
    margin-left: 1em;
  }
</style>
